import { ReactElement, ReactNode } from 'react';
import { Tooltip } from 'src/components';
import { TOOLTIP_PAPER_STYLE_SLOT_PROPS } from 'src/components/Tooltip/tooltip-paper-style-slot-props';

interface ConversationTooltipProps {
  anchorEl: HTMLElement | null;
  children: ReactElement;
  enterDelay: number;
  isOpen: boolean;
  leaveDelay: number;
  title: ReactNode;
}

export const ConversationTooltip = ({
  anchorEl,
  children,
  enterDelay,
  isOpen,
  leaveDelay,
  title,
}: ConversationTooltipProps) => (
  <Tooltip
    hideWhenRefIsHidden
    disableTouchListener
    disableHoverListener
    disableFocusListener
    nonInteractable={false}
    open={isOpen}
    enterDelay={enterDelay}
    leaveDelay={leaveDelay}
    placement="left"
    slotProps={{
      ...TOOLTIP_PAPER_STYLE_SLOT_PROPS,
      popper: {
        ...TOOLTIP_PAPER_STYLE_SLOT_PROPS.popper,
        anchorEl,
      },
    }}
    title={title}
  >
    {children}
  </Tooltip>
);
